import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debugTypes } from '../debug-container/debug-container.component';

export interface DebugEvent {
  category: debugTypes;
  request?: unknown;
  response?: unknown;
  type?: 'success' | 'info' | 'warning' | 'error' | 'blank';
}


@Injectable({
  providedIn: 'root'
})
export class DebugEventService {
  private subject = new Subject<DebugEvent>();

  // enable subscribing to alerts observable
  onAlert(): Observable<DebugEvent> {
    return this.subject.asObservable();
  }
  // main alert method
  alert(event: DebugEvent) {
    this.subject.next(event);
  }

}
